import React from 'react';
import { useContext, useState } from 'react';
import dayjs from 'dayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField, Select, MenuItem, Container, Button, Box, Typography, Grid } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Spinner } from '/@/app/components/Spinner';
import { messageStackState } from "/@/app/states/messageStackState";

//
import { AppContext } from '/@/app/AppContext';
import { useApi} from '/@/app/Api';
import { route } from '/@/app/routes';


const Item = styled(Box)(({ theme }) => ({
    backgroundColor: '#f5f7fb',
    ...theme.typography.body2,

    borderRadius: theme.shape.borderRadius * 1.5,
    padding: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
        padding: theme.spacing(3),
    },
    [theme.breakpoints.up('lg')]: {
        padding: theme.spacing(4.5),
    },
    //
    textAlign: "left",
    color: theme.palette.text.primary,
}));


export const FinishRegistrationView = () => {
    const api=useApi();
    const { bootstrapData } = useContext(AppContext);
    const user = bootstrapData.user;
    let changeAllowed = true;
    if (!user.details_set_at) {
        changeAllowed = true;
    } else {
        if (dayjs(user.details_set_at).add(user.details_change_period, 'day').isAfter(dayjs())) {
            changeAllowed = true;
        } else {
            changeAllowed = false;
        }
    }

    const [birthday, setBirthday] = useState(user.birthday ? dayjs(user.birthday) : null);
    const [gender, setGender] = useState(user.gender || "");

    const handleGenderChange = (event) => {
        setGender(event.target.value);
    };

    const [saving, setSaving] = useState(false);
    const [saveStatus, setSaveStatus] = useState(null);
    const handleSave = () => {
        if (saving) {
            return;
        }
        if (!birthday || !gender) {
            messageStackState.addMessage({text: "Заполните все поля", tags: "error", autoHide: 2000});
            return;
        }
        setSaving(true);
        api.request(`cabinet/user/registration-details/`,{ gender: gender, birthday: birthday.format('YYYY-MM-DD'), }, { method: 'PUT', })
	.then(() => {
            setSaveStatus("success");
            location.href = route("/");  // reload just because user's data changes are not reactive.
        }).finally(() => {
            setSaving(false);
        });
    }

    return (
        <Container maxWidth="md">
            <Typography variant="h3" gutterBottom>Завершите регистрацию</Typography>
            <Item>
                <Grid container spacing={2} sx={{textAlign: "center" }}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom>Дата рождения</Typography>
                        <DatePicker
                            readOnly={saving || !changeAllowed}
                            openTo="year"
                            views={['year', 'month', 'day']}
                            value={birthday}
                            onChange={(newValue) => setBirthday(newValue)}
                            components={{
                                textField: TextField,
                            }}
                            componentsProps={{
                                textField: {
                                    helperText: 'Ваш возраст нужен для расчёта',
                                },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h5" gutterBottom>Пол</Typography>
                        <Select
                            value={gender}
                            readOnly={saving || !changeAllowed}
                            onChange={handleGenderChange}
                            sx={{
                                minWidth: "150px",
                            }}
                        >
                            <MenuItem value="male">Муж</MenuItem>
                            <MenuItem value="female">Жен</MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={12}>
                        {changeAllowed ?
                            <>
                                <Button variant="contained" color="primary" onClick={handleSave}>Сохранить</Button>
                                <Typography variant="body2" gutterBottom sx={{ mt: 2}}>
                                    Данные можно будет изменить в течение {user.details_change_period} дней.
                                    Позже - только через администратора Nestarenie.Expert.
                                </Typography>
                            </>
                            : <Typography variant="body2" gutterBottom sx={{ mt: 2}}>
                                Если вы хотите изменить данные, обратитесь к администратору Nestarenie.Expert.
                            </Typography>
                        }
                    </Grid>
                </Grid>
            </Item>
            {saving && <Box sx={{textAlign: "center"}}><Spinner size={60} delay={500} sx={{mt:2}} /></Box>}
        </Container>
    )
}
